module.exports = __webpack_public_path__ + "static/img/fuwu6.e48ca20.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/productAndService/fuwu6.png
// module id = Bycq
// module chunks = 1